import { Flex, Text, Title } from '@tremor/react';
import s from './ConfirmDeletionModal.module.scss';
import { GeneralModalProps } from '@/types/modals';
import { ModalWrapper } from '../ModalWrapper/ModalWrapper';
import { OutlinedButton } from '../../Buttons/OutlinedButton/OutlinedButton';
import { ReactNode } from 'react';

interface Props extends GeneralModalProps {
  onConfirm: () => void;
  message: string | ReactNode;
  isLoading?: boolean;
  title: string;
}
export function ConfirmDeletionModal({ setClose, isOpen, ...rest }: Props) {
  return (
    <ModalWrapper className={s.modal} isOpen={isOpen} onRequestClose={setClose}>
      <ConfirmDeletionModalContent
        setClose={setClose}
        {...rest}
      ></ConfirmDeletionModalContent>
    </ModalWrapper>
  );
}

type ContentProps = Pick<
  Props,
  'setClose' | 'onConfirm' | 'message' | 'isLoading' | 'title'
>;

function ConfirmDeletionModalContent({
  setClose,
  onConfirm,
  message,
  isLoading = false,
  title,
}: ContentProps) {
  function getContent() {
    if (typeof message === 'string') return <Text>{message}</Text>;
    return message;
  }
  return (
    <section>
      <Title>{title}</Title>
      {getContent()}
      <Flex justifyContent="start" style={{ marginTop: '20px' }}>
        <OutlinedButton disabled={isLoading} onClick={setClose}>
          Cancel
        </OutlinedButton>
        <OutlinedButton
          isLoading={isLoading}
          className={s.confirmButton}
          onClick={onConfirm}
          spinnerSize="20px"
          spinnerColor="red"
        >
          Confirm
        </OutlinedButton>
      </Flex>
    </section>
  );
}
